<template>
  <div>
    <!-- loading -->
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="cyan px-4"
    ></v-progress-linear>

    <!-- viewer -->
    <div v-else class="mx-4 mt-2 qimg" v-dompurify-html="contentData"></div>
  </div>
</template>

<script>
import Vue from "vue";
import firebase from "firebase";
import VueDOMPurifyHTML from "vue-dompurify-html";
Vue.use(VueDOMPurifyHTML, {
  default: {
    ADD_TAGS: ["iframe"], // this one whitelists Youtube
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"]
  },
});
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import VueMq from "vue-mq";
Vue.use(VueMq, {
  breakpoints: {
    // default breakpoints - customize this
    sp: 959,
    pc: 960,
  },
  defaultBreakpoint: "pc", // customize this for SSR
});
import axios from "axios";
import VueAxios from "vue-axios";
Vue.use(VueAxios, axios);

export default {
  name: "contentViewer",
  props: ["fullPath"],
  data: () => ({
    loading: true,
    contentData: "",
  }),
  created() {
    this.getContent();
  },
  computed: {
    isSp() {
      return this.$mq === "sp";
    },
    isAdmin() {
      return !this.isSp && (this.$store.state.isAdmin||(this.aboutLid&&this.aboutLid.lidAdmin&&this.aboutLid.lidAdmin.includes(this.$store.state.auth?.user?.uid || '')))
    },
    lid() {
      return this.$store.state.lid;
    },
    alid() {
      return this.$store.state.alid;
    },
    aboutLid() {
      if (this.$store.state.lid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.lid.filter((u) => u.id === this.$route.params.id)[0]
        } else if (this.$store.state.alid.some((u) => u.id === this.$route.params.id)) {
          return this.$store.state.alid.filter((u) => u.id === this.$route.params.id)[0]
        } else {
          return null
        }
    },
  },
  methods: {
    textConverter (text) {
      return text
        .replaceAll("width=", "max-width='100%' width=")
        .replaceAll('class="ql-align-center"', 'class="ql-align-center" style="text-align: center;"')
        .replaceAll('class="ql-align-right"', 'class="ql-align-right" style="text-align: right;"')
        .replaceAll('class="ql-align-justify"', 'class="ql-align-justify" style="text-align: justify;"')
        .replaceAll(`<p>`, `<p style="margin-bottom:0">`)
        // aタグのうち、中身がテキストのものは外部リンクである表示を追加。imgタグは無視
        .replace(/<a href="https?:\/\/(?!localhost)(.+?)".*?>([^<img].+?)<\/a>/g, (match, p1, p2) => {
          return `<a href="https://${p1}" target="_blank" rel="noopener noreferrer">${p2}<span class="mdi mdi-open-in-new"></span></a>`;
        })
        .replace(/<iframe.*?style="(.+?)".*?<\/iframe>/g, (match, p1) => {
          return match.replace(p1, `${p1}; aspect-ratio: 16 / 9 !important; max-width: 100%;`);
        })
        .replace(/<img.*?style="(.+?)".*?>/g, (match, p1) => {
          return match.replace(p1, `${p1}; max-width: 100%;`);
        })
    },
    getContent: async function () {
      const self = this;
      const path = this.fullPath
      if (!path) {
        return
      }
      // 先にFirestoreでの取得にトライする
      // fullPathは projects/[lidId]/[projectId]/proposal/[proposalId] こんな感じ
      const [_, lidId, projectId, __, proposalId] = path.split('.')[0].split('/');
      const docPath = '/0/' + lidId + '/project/' + projectId + '/proposals/' + proposalId;
      const doc = await firebase.firestore().doc(docPath).get();
      if (doc.exists) {
        const data = doc.data();
        if (data?.content) {
          const content = this.textConverter(data.content)
          self.contentData = content;
          self.loading = false;
          self.$emit('setData', content);
          return;
        }
      } else {
        console.log("No such document!", docPath);
      }
      // なければ以下の処理が続く
      const ref = await firebase.storage().ref(path);
      // ダウンロードURLを取得
      await ref
        .getDownloadURL()
        .then((downloadLink) => {
          this.axios.get(downloadLink).then((res) => {
            const content = this.textConverter(res.data)
            self.contentData = content
            self.loading = false
            self.$emit('setData', content);
          });
        })
        .catch((error) => {
          console.error(error);
        });
      self.loading = false;
    },
  },
};
</script>
<style scoped>
.cloud {
  color: #707070;
}
.folded {
  position: relative;
  overflow: hidden;
  height: 55vh;
}
.folded::before {
  display: block;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  content: "";
  height: 50px;
  background: -webkit-linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 50%,
    #fff 100%
  );
  background: linear-gradient(
    top,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0.8) 50%,
    #fff 100%
  );
}
.qimg > div > p > img {
  max-width: 100% !important;
  height: auto !important;
}
.qimg > div > h2 > img {
  max-width: 100% !important;
  height: auto !important;
}
.qimg >>> img {
  max-width: 100% !important;
  height: auto !important;
}
</style>
